<template>
  <b-container
    fluid="md"
    class="square-payment-rate-limit-exceeded-error"
  >
    <b-row>
      <b-col>
        <div class="title pb-4">
          <span class="icon-container">
            <font-awesome-icon
              icon="triangle-exclamation"
              size="2x"
              class="icon"
              fixed-width
              color="red"
            />
          </span>
          <span class="h3 pr-4">
            Rate Limit Exceeded
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="error-message">
          <p>
            The system has detected a large of similar requests in a short period of time. This has triggered the
            rate limits that protect the system from potentially fraudlent or malicious activity.
          </p>
          <p>
            If you are attempting to process a legitimate request, you will be permitted to process
            continue processing once the system after a short delay. Please try again shortly.
          </p>
          <p>
            If you would like further information please contact the site admin.
          </p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'payment-rate-limit-exceeded-error',
  props: {
    error: {
      type: [Object, Error],
      required: true
    }
  },
  computed: {
  }
}
</script>

<style>

</style>
